<template>
  <div>
    <!--<div class="firstcolumn_tip">-->
      <!--&lt;!&ndash;<img :src="puxi" alt="">&ndash;&gt;-->
      <!--推荐人物-->
    <!--</div>-->
    <div class="pushu_nav">
      <div class="columnBoxInnner">
        <div class="columnBoxInnnerList">
          <span v-for="(item,index) in renwuType" :key="index" :class="currentPuxi==index?'activenames':'names'" @click="gopushu(item,index)"><span class="span_name">{{ item.DICTIONARY_NAME }}</span><span v-if="index!=renwuType.length-1" style="margin: 0 8px;">/</span></span>
        </div>
      </div>
    </div>
    <div v-if="renwuData.length>0" class="center">
      <div v-for="(item,index) in renwuData" :key="index" class="puxi_content">
        <div class="libox">
          <div class="topColumnname" @click="gorenwu">
            人物
          </div>
          <a class="imgbox" :href="'/sourceView?sourceId='+item.SHOW_RES_ID+'&type='+item.SHOW_TYPE" target="_blank">
            <img v-if="item.COVER&&!item.COVER_NAME" :src="item.COVER" alt="">
            <p v-else style="height: 183px;text-align: center;font-size: 30px;font-weight: 600;background-color: #D8D2CD;line-height: 183px;">
              {{ item.COVER_NAME }}
            </p>
          </a>
          <p>{{ item.SHOW_TITLE }}</p>
        </div>
      </div>
    </div>
    <div v-else style="text-align: center;font-size: 20px;color: #a19d9e;font-weight: 600;background-color: #ffffff;height: 150px;line-height: 150px;">
      暂无数据
    </div>
    <div class="addMore" @click="addMore">
      <span class="addMore_span">查看更多</span>
      <!--<span v-show="loadAll">已经到底了</span>-->
    </div>
  </div>
</template>
<script>
// ///首页列表模板上中下形式
import { getClassz, getdataNodeList } from '@/api/api.js'
export default {
  data() {
    return {
      currerntPage: 1,
      currentType: '',
      loadAll: false,
      renwuData: [],
      renwuType: [{ DICTIONARY_ID: '', DICTIONARY_NAME: '最新推荐' }],
      currentPuxi: 0,
      puxi: require('@/static/renwu.png'),
      puxidata: [
        { imgurl: require('@/static/puxiimg1.png'), tips: '近代名人', content: '彭氏迁徙史' },
        { imgurl: require('@/static/puxiimg2.png'), tips: '近代名人', content: '彭氏迁徙史' },
        { imgurl: require('@/static/puxiimg3.png'), tips: '近代名人', content: '彭氏迁徙史' },
        { imgurl: require('@/static/puxiimg4.png'), tips: '近代名人', content: '彭氏迁徙史' }
      ]
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    this.initType()
  },
  methods: {
    // /查询字典
    initType() {
      getClassz({ classCode: 'nodeType' }).then(res => {
        this.renwuType = this.renwuType.concat(res.data)
        // console.log(res.data)
      })
    },
    initData() {
      getdataNodeList({ page: 1, limit: 4 }).then(res => {
        // console.log(res.data)
        this.renwuData = res.data.listMapData
        var str = /^http/
        for (var i = 0; i < this.renwuData.length; i++) {
          if (this.renwuData[i].COVER) {
            if (!str.test(this.renwuData[i].COVER)) {
              this.renwuData[i].COVER_NAME = this.renwuData[i].COVER
            }
          }
        }
        if (res.data.count <= 4) {
          this.loadAll = true
        }
      })
    },
    gopushu(names, index) {
      this.loadAll = false
      this.currerntPage = 1
      this.currentType = names.DICTIONARY_ID
      getdataNodeList({ page: 1, limit: 4, type: names.DICTIONARY_ID }).then(res => {
        this.renwuData = res.data.listMapData
        var str = /^http/
        for (var i = 0; i < this.renwuData.length; i++) {
          if (this.renwuData[i].COVER) {
            if (!str.test(this.renwuData[i].COVER)) {
              this.renwuData[i].COVER_NAME = this.renwuData[i].COVER
            }
          }
        }
        if (res.data.count <= 4) {
          this.loadAll = true
        }
      })
      this.currentPuxi = index
    },
    addMore() {
      this.$router.push({ path: '/nodeList' })
      // this.currerntPage++
      // getdataNodeList({ page: this.currerntPage, limit: 4, type: this.currentType }).then(res => {
      //   this.renwuData = this.renwuData.concat(res.data.listMapData)
      //   var str = /^http/
      //   for (var i = 0; i < this.renwuData.length; i++) {
      //     if (this.renwuData[i].COVER) {
      //       if (!str.test(this.renwuData[i].COVER)) {
      //         this.renwuData[i].COVER_NAME = this.renwuData[i].COVER
      //       }
      //     }
      //   }
      //   if (res.data.page <= this.currerntPage) {
      //     this.loadAll = true
      //   }
      // })
    },
    gorenwu() {
      this.$router.push({ path: '/nodeList' })
    },
    goDetail(sourceId, type) {
      const { href } = this.$router.resolve({
        url: '/sourceView',
        name: 'sourceView',
        query: {
          sourceId,
          type
        }
      })
      window.open(href, '_blank')
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .firstcolumn_tip{
      margin-top: 20px;
      height: 68px;
      /*border: 1px solid #f0f0f0;*/
      text-align: center;
      line-height: 68px;
      background-color: #fff;
      font-size: 24px;
      color: #353535;
      font-weight: 600;
        img{
            width: auto;
            height: 29px;
            margin-top: 20px;
        }
    }
    .pushu_nav{
        overflow: hidden;
        text-align: center;
        background-color: #fff;
        height: 60px;
        line-height: 60px;
        span{
            font-size: 16px;
            color: #333333;
        }
      .names{
        .span_name{
          cursor: pointer;
          color: #333333;
          font-weight: 600;
        }
      }
      .activenames{
        .span_name{
          cursor: pointer;
          color: #E3003A;
          font-weight: 600;
        }
      }
    }
    .addMore{
      text-align: center;
      height: 45px;
      line-height: 45px;
      font-size: 14px;
      color: #999999;
      background-color: #fff;
      border: 1px solid #e5e5e5;
      border-radius: 3px;
      cursor: pointer;
      display:inline-block;
      width: 1198px;
      transition: 0.5s;
      margin-top: 20px;
      margin-bottom: 20px;
      &:hover{
        color: #ed4040;
        border: 1px solid #ed4040;
      }
    }
    .center{
        overflow: hidden;
        padding-bottom: 20px;
        .puxi_content{
          background-color: #fff;
            display: inline-block;
            margin-right: 33px;
            margin-top: 20px;
            width: 275px;
          overflow: hidden;
            transition: 0.3s;

            &:hover{
                transform: translate(0,-3px);
            }
            .libox{
                display: inline-block;
                width: 100%;
                font-size: 0;
                position: relative;
                .topColumnname{
                    text-align: center;
                    position: absolute;
                    top:10px;
                    left: 10px;
                  padding: 0 5px;
                    background-color:rgba(51,51,51,.5);
                    font-size: 12px;
                    color: #ffffff;
                    height: 18px;
                    line-height: 18px;
                    border-radius: 3px;
                    cursor: pointer;
                    &:hover{
                        background-color: rgba(237,64,64,.5);
                    }
                }
                .imgbox{
                    display: inline-block;
                    width: 275px;
                    height: 183px;
                    font-size: 0;
                    cursor: pointer;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                p{
                    width: 265px;
                    height: 46px;
                    text-align: left;
                    padding-left: 10px;
                   background-color: #666666;
                   line-height: 46px;
                  color: #ffffff;
                    .titlename{
                        color: #333333;
                        font-size: 14px;
                        font-weight:500;
                        display: inline-block;
                        padding-top: 8px;
                        height:55px;
                        line-height: 25px;
                        width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    .hot_time{
                        display: inline-block;
                        width: 155px;
                        height: 20px;
                        margin-top: 5px;
                        font-size: 12px;
                        color: #b2b2b2;
                    }
                    .viewNumber{
                        display: inline-block;
                        height: 20px;
                        width: 50px;
                        margin-top: 10px;
                        font-size: 12px;
                        color: #b2b2b2;
                        svg{
                            vertical-align:middle;
                        }
                    }
                    .viewStar{
                        width: 50px;
                    }
                }
            }
        }
        .puxi_content:nth-child(4n){
        margin-right: 0;
      }
    }
</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .columnBoxInnner{
      width: 100%;
      overflow: hidden;
      padding-bottom: 20px;
      overflow-x: auto;
      .columnBoxInnnerList{
        white-space: nowrap;
        padding: 0 20px;
      }
    }

    .center .puxi_content{
      display: block;
      margin: 0 auto 20px;
    }
  }
</style>
